import React, { createContext, useState, useContext } from 'react';
import JoinModal from './JoinModal';

// Create context
const JoinModalContext = createContext();

// Provider component
export const JoinModalProvider = ({ children }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  
  const openModal = () => {
    setIsModalOpen(true);
  };
  
  const closeModal = () => {
    setIsModalOpen(false);
  };
  
  return (
    <JoinModalContext.Provider value={{ openModal, closeModal }}>
      {children}
      <JoinModal isOpen={isModalOpen} onClose={closeModal} />
    </JoinModalContext.Provider>
  );
};

// Custom hook for components to access modal functions
export const useJoinModal = () => {
  const context = useContext(JoinModalContext);
  if (!context) {
    throw new Error('useJoinModal must be used within a JoinModalProvider');
  }
  return context;
}; 